(() => {
  const initProductSections = (scope = document) => {
    scope.querySelectorAll('[data-product-section]').forEach((section) => {
      if (section.dataset.productReady === 'true') return;
      section.dataset.productReady = 'true';

      const selector = section.querySelector('[data-product-variant-selector]');
      const updateVariantUi = () => {
        if (!selector) return;
        const option = selector.options[selector.selectedIndex];
        const available = option.dataset.available === 'true';

        section.querySelectorAll('[data-product-price]').forEach((price) => {
          price.textContent = option.dataset.price || '';
        });
        section.querySelectorAll('[data-product-compare-price]').forEach((compare) => {
          const compareValue = option.dataset.comparePrice || '';
          compare.textContent = compareValue;
          compare.hidden = !compareValue || compareValue === option.dataset.price;
        });
        section.querySelectorAll('[data-product-submit], [data-sticky-submit]').forEach((button) => {
          button.disabled = !available;
        });
        section.querySelectorAll('[data-product-submit-label]').forEach((label) => {
          label.textContent = available ? section.dataset.addLabel : section.dataset.soldOutLabel;
        });
        section.querySelectorAll('[data-sticky-variant]').forEach((variant) => {
          variant.textContent = option.textContent.replace(/\s+[—-]\s+.*$/, '').trim();
        });
      };

      if (selector) selector.addEventListener('change', updateVariantUi);
      updateVariantUi();

      const sticky = section.querySelector('[data-sticky-atc]');
      const mainButton = section.querySelector('[data-product-submit]');
      if (sticky && mainButton && 'IntersectionObserver' in window) {
        const stickyObserver = new IntersectionObserver(([entry]) => {
          sticky.classList.toggle('is-active', !entry.isIntersecting);
        }, { threshold: 0 });
        stickyObserver.observe(mainButton);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductSections());
  } else {
    initProductSections();
  }
  document.addEventListener('shopify:section:load', (event) => initProductSections(event.target));
})();
